import { useLazyLoadQuery } from 'react-relay';
import { getAssignmentStudentDashboard } from '../../graphQLOperations/Assignment';
import { StudentDashboardAssignmentCard } from './StudentDashboardAssignmentCard';
import { AssignmentItemList } from '../../models/Assignment';
import { Link } from 'react-router-dom';
import { FC } from 'react';
import { AssignmentGetAssignmentStudentDashboardQuery } from '../../graphQLOperations/__generated__/AssignmentGetAssignmentStudentDashboardQuery.graphql';
import { startOfDay } from 'date-fns';

export const StudentDashboardAssignments: FC = () => {
  const now = new Date();
  const dueOnFrom = startOfDay(now);
  const { assignments } = useLazyLoadQuery<AssignmentGetAssignmentStudentDashboardQuery>(
    getAssignmentStudentDashboard,
    {
      first: 1,
      order: [{ dueOn: 'ASC' }],
      filter: {
        startedOnTo: now,
        dueOnFrom,
        isActive: 'ACTIVE',
      },
    },
    { fetchPolicy: 'network-only' },
  );

  const totalCount = assignments?.totalCount || 0;

  return (
    <div className={`tw-w-full border-bottom-1 surface-border ${totalCount > 0 ? '' : 'tw-hidden'}`}>
      <div className="flex justify-content-between">
        <h3 className="font-bold inline">Teacher Assignment{totalCount > 1 ? `s (${totalCount})` : ''}</h3>
        <div className={`${totalCount > 1 ? '' : 'tw-hidden'}`}>
          <span className={`tw-mr-2`}>
            You have a total of <b>{totalCount} assignments.</b>{' '}
          </span>
          <Link to={'/assignments'} className="font-semibold text-primary cursor-pointer">
            View all →
          </Link>
        </div>
      </div>
      <div className="tw-pb-4 tw-pt-2">
        {assignments?.nodes?.length ? (
          <StudentDashboardAssignmentCard
            type="CURRENT"
            assignment={assignments.nodes[0] as AssignmentItemList}
            headingLevel="h4"
          />
        ) : (
          <div className="py-7">
            <p className="w-8 mx-auto font-semibold bg-light-blue p-4 text-center border-round-md">{`No assignments for now — you're all caught up!`}</p>
          </div>
        )}
      </div>
    </div>
  );
};
